import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { Button } from "@/components/ui/button";
import CredentialsHeader from "@/components/header/Header";
import CredentialsFooter from "@/components/footer/Footer";
import NeedHelpButton from "@/components/need-help-button/need-help-button";

import { LoyaltyCardAssociationResponse } from "@/models/shared/loyalty/LoyaltyCardAssociationResponse";
import useFooterDisplayMode from "@/hooks/useFooterDisplayMode";

export default function LoyaltyCcvCommunication() {
  const location = useLocation<LoyaltyCardAssociationResponse>();
  const { t } = useTranslation();
  const { displayMode, excludeAssetKey } = useFooterDisplayMode();

  const history = useHistory();
  const handleSubmit = async () => {
    // deadEnd is where this interstitial hands off to — it may be the consents gate. The pushed
    // state must advertise THAT url as nextStep, otherwise the destination screen keeps posting
    // back to /api/card/ccv-communication, which is a client-only route with no backend handler.
    history.push(location.state.properties.deadEnd.substring(4), {
      ...location.state,
      nextStep: location.state.properties.deadEnd,
    });
  };

  window.addEventListener("popstate", (event) => {
    history.push("/");
  });

  return (
    <div className="flex flex-col gap-12 pb-2">
      <CredentialsHeader title={t("loyalty_ccv_comunication.header_title")} />
      {displayMode !== "none" && (
        <div
          role="note"
          aria-label={t(displayMode === "carousel" ? "accessibility.loyaltycard.loyalty_ccv_communication.icons_carousel" : "accessibility.loyaltycard.loyalty_ccv_communication.icons")} className="flex flex-col">
          <CredentialsFooter
            contextualInformationVisible
            displayMode={displayMode}
            excludeAssetKey={excludeAssetKey}
            message={t("loyalty_ccv_comunication.header_message")}
          />
        </div>
      )}
      <div className="flex justify-center">
        <Button
          type="button"
          onClick={handleSubmit}
        >
          {t("loyalty_ccv_comunication.button_close_message")}
        </Button>
      </div>
      <NeedHelpButton />
    </div>
  );
}
